let url = 'http://127.0.0.1:8000/';
url = 'https://bkhotelvillazon.merkancia360.com/public/';
url = 'https://bkvillazon.centervillazon.com/public/';

export const environment = {
  env: 'PROD',
  production: true,
  serverBaseUrl: url + 'api',
  serverUrl: url + 'api',
  imgUrl: url + ''
};
